import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { gqlDraftOutboundDelivery } from '../../gql'
import { useQuery } from '@apollo/client'
import { formatDateStringForDisplay } from '../../lib/utils'
import { Pagination } from '../../components'
import { useTranslation } from 'react-i18next'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material'
function DeliveryNote({ orderId }) {
  const { t } = useTranslation('delivery_note')
  const [deliveryNotes, setDeliveryNotes] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [first, setFirst] = useState(rowsPerPage)
  const [last, setLast] = useState(null)
  const [after, setAfter] = useState(null)
  const [before, setBefore] = useState(null)
  const [page, setPage] = useState(0)
  const [pageInfo, setPageInfo] = useState(null)
  const [totalCount, setTotalCount] = useState(0)
  const totalPages = Math.ceil(totalCount / rowsPerPage) ?? 0
  const {
    data,
    error: errorOutboundDelivery,
    loading: loadingOutboundDelivery,
  } = useQuery(gqlDraftOutboundDelivery.DRAFT_OUTBOUND_DELIVERIES_BY_COMMAND_ID, {
    variables: {
      first,
      after,
      before,
      last,
      idSaleOrder: orderId,
    },
  })
  const error = errorOutboundDelivery
  const loading = loadingOutboundDelivery
  useEffect(() => {
    if (data) {
      const transformedDL = data.draftOutboundDeliveries.edges.map(({ node }) => ({
        ...node,
        id: node.id,
        clientName: node.saleOrderClientName,
        createdDate: formatDateStringForDisplay(node.createdAt),
        licensePlate: node.truckLicencePlate,
        materials: node.draftOutboundDeliveryItemsByIdDraftOutboundDelivery.edges.map(
          ({ node }) => ({
            id: node.id,
            materialId: node.materialByIdMaterial.id,
            name: node.materialByIdMaterial.description,
            internalId: node.materialByIdMaterial.internalId,
            unit: node.materialByIdMaterial.measureUnitByBaseMeasureUnitCode?.abbr,
            quantity: node.quantity.toString(),
          })
        ),
      }))    
      setDeliveryNotes(transformedDL) ;
      // Set totalCount based on transformedDL length
      setPageInfo(data.draftOutboundDeliveries.pageInfo)
      setTotalCount(data.draftOutboundDeliveries.totalCount)
    }
  }, [data])



  const handleChangePage = (newPage, type) => {
    const isNext = type === 'next'
    setAfter(isNext ? pageInfo.endCursor : null)
    setBefore(isNext ? null : pageInfo.startCursor)
    setFirst(isNext ? rowsPerPage : null)
    setLast(isNext ? null : rowsPerPage)
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage)
    setFirst(newRowsPerPage)
    setLast(null)
    setAfter(null)
    setBefore(null)
    setPage(0)
  }
  return (
    <>
      {/* Ajouter ici le contenu spécifique aux bons de livraison */}
      <Card>
        <CardContent>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
              <CircularProgress
                size={80}
                sx={{
                  svg: {
                    width: '100%',
                    height: '100%',
                    viewBox: '0 0 40 40',
                  },
                }}
              />
            </Box>
          ) : error ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
              <Typography color="error"> {t('errorLoadingData')}</Typography>
            </Box>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  {totalCount > 0 ? (
                    deliveryNotes.map((deliveryNote) => {
                      return (
                        <TableRow key={deliveryNote.id}>
                          <TableCell>
                            <div>{deliveryNote.createdDate}</div>
                            <div className="bold">{deliveryNote.clientName}</div>
                          </TableCell>
                          <TableCell>
                            <div className="bold">{deliveryNote.licensePlate}</div>
                          </TableCell>

                          <TableCell>
                            <div
                              style={{
                                minWidth: '150px',
                                maxHeight: '150px',
                                overflowY: 'auto',
                              }}
                            >
                              {deliveryNote?.materials?.map((material, index) => (
                                <div key={index}>
                                  <span className="bold">
                                    {material.internalId}-{material.name}
                                  </span>{' '}
                                  , {material.quantity} {material.unit}
                                </div>
                              ))}
                            </div>
                          </TableCell>
                        </TableRow>
                      )
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3}>
                        <div style={{ textAlign: 'center', padding: '20px' }}>{t('noData')}</div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {
            <Pagination
              page={page}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          }
        </CardContent>
      </Card>
    </>
  )
}
DeliveryNote.propTypes = {
  orderId: PropTypes.string.isRequired,
}

export default DeliveryNote
